import { ButtonProps } from 'antd';
import PlusIcon from './PlusIcon';
import { useFormikContext } from 'formik';
import { useBox44Context } from '../Box44';
import { ReactElement, useMemo } from 'react';
import { SBox44Button } from './styles';

interface Box44ButtonProps extends ButtonProps {
    itemNumber?: number;
}

// TODO: Update the text in the button when we're able to get the number of items per house consignment and number of master items
const Box44Button = ({ itemNumber, ...props }: Box44ButtonProps): ReactElement => {
    const formik = useFormikContext();
    const { path } = useBox44Context();

    const numberOfCodes = useMemo(() => {
        const value = (formik.getFieldMeta(path).value ?? {}) as Record<string, any>;
        return Object.values(value).length;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.getFieldMeta(path).value, path]);

    return (
        <SBox44Button size="small" data-testid={'box-44-codes-button'} {...props}>
            <PlusIcon /> Box 44 Codes ({numberOfCodes}){itemNumber !== undefined && ` | Item ${itemNumber}`}
        </SBox44Button>
    );
};

export default Box44Button;
